import React from 'react';
import {ExperienceGroup} from "contracts/holotrak/experienceGroup";

export const OrganisationContext = React.createContext<ExperienceGroup>({} as ExperienceGroup);
